import { ParseKeys } from "i18next";

export type UIErrorMesage = ParseKeys<"error"> | string;
export type UIErrorSeverity = "error" | "warning";

export default class UIError extends Error {
    message: UIErrorMesage;
    severity: UIErrorSeverity;
    /** Texto crudo (sin traducir) a mostrar en vez de resolver `message` como clave de i18n. */
    details?: string;

    constructor(message: UIErrorMesage, severity: UIErrorSeverity = "error", details?: string) {
        super(message);

        this.name = "UIError";
        this.message = message.toCamelCase();
        this.severity = severity;
        this.details = details;
    }
}
